<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование сайта" : "Добавление сайта"'
    subtitle='Сайты'
  )
  v-card
    v-tabs(v-model='active' color='dark' slider-color='primary')
      v-tab {{ id ? item.name : "Сайт" }}
      v-tab-item(:transition='false' :reverse-transition='false')
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs12 sm6)
                v-text-field(
                  :error='errors.has("code")'
                  :error-messages='errors.first("code")'
                  v-model='item.code'
                  label='Код сайта'
                  :disabled='!!id'
                )
            v-flex(xs12 sm6)
              s-complex-picker(
                :error='errors.has("complex_id")'
                :error-messages='errors.first("complex_id")'
                label='Комплекс'
                v-model='item.complex_id'
              )
            v-flex(xs12 sm6)
              v-text-field(
                :error='errors.has("name")'
                :error-messages='errors.first("name")'
                v-model='item.name'
                label='Название сайта или ЖК'
              )
            v-flex(xs12 sm6)
              v-text-field(
                :error='errors.has("url")'
                :error-messages='errors.first("url")'
                v-model='item.url'
                label='Ссылка на сайт'
              )
            v-flex(xs12)
              v-text-field(
                v-model='item.default_meta.title'
                label='META title по умолчанию'
              )
            v-flex(xs12)
              v-textarea(
                v-model='item.default_meta.description'
                label='META description по умолчанию'
              )    
            v-flex(xs12)
              s-file-upload(
                v-model='item.doc_soglasie',
                :file='item.doc_soglasie_url',
                :record-id='item.id',
                :parseResponse='(v) => v.hash',
                @remove-success='onRemoveSoglasie',
                label='Согласие на хранение данных'
              )          
            v-flex(xs12)
              s-file-upload(
                v-model='item.doc_soglasie_sharing',
                :file='item.doc_soglasie_sharing_url',
                :record-id='item.id',
                :parseResponse='(v) => v.hash',
                @remove-success='onRemoveSharing',
                label='Согласие на распространение данных'
              )    
            v-flex(xs12)
              s-file-upload(
                v-model='item.doc_politica',
                :file='item.doc_politica_url',
                :record-id='item.id',
                :parseResponse='(v) => v.hash',
                @remove-success='onRemovePolitica',
                label='Политика конфиденциальности'
              )          
              template(v-if='id')
      v-tab Уведомления
      v-tab-item
        notifications(:emails='item.emails', :siteId='id')
    v-card-actions(v-if='actionsShown' class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='onSave'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Notifications from './Notifications'

// Индексы вкладок, на которых нужно скрыть кнопки
// Сохранить/Отмена
const actionsHiddenTabs = [1]

export default {
  props: ['id'],

  components: {
    Notifications,
  },
  data: function() {
    return {
      item: {
        default_meta: {},
        site_settings: {},
        social: {}
      },
      active: 0,
      genplan: {
        options: {
          minZoom: 0,
          url: null,
          width: 0,
          height: 0
        },
        opened: false,
        objects: []
      }
    }
  },

  async mounted() {
    if (this.id) {
      try {
        this.item = (
          await this.fetchSingle({
            id: this.id
          })
        ).data
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки сайта')
      }
    }
  },

  methods: {
    onRemoveSoglasie() {
      this.item.doc_soglasie = null
      this.item.doc_soglasie_url = null
    },
    onRemoveSharing() {
      this.item.doc_soglasie_sharing = null
      this.item.doc_soglasie_sharing_url = null
    },
    onRemovePolitica() {
      this.item.doc_politica = null
      this.item.doc_politica_url = null
    },
    async onSave() {
      let data = this.item
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data
          })
        } else {
          await this.create({ data })
        }

        this.$root.showSnack('Сайт сохранен')
        this.$router.push({ name: 'Content.Sites' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('content/sites', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    // Не будем показывать кноки Сохарнить/Отмена
    // на некоторых вкладках
    actionsShown() {
      return !actionsHiddenTabs.includes(this.active)
    },
    ...mapGetters('content/sites', ['isLoading'])
  }
}
</script>
